import { Directive } from '@angular/core';
import {AbstractControl, NG_VALIDATORS} from "@angular/forms";
import {CustomValidationService} from "../services/custom-validation.service";

@Directive({
  selector: '[app-addressStreet]',
  providers: [{ provide: NG_VALIDATORS, useExisting: AddressStreetPatternDirective, multi: true }]
})
export class AddressStreetPatternDirective {

  constructor(private customValidator: CustomValidationService) { }

  validate(control: AbstractControl): { [key: string]: any } | null {
    return this.customValidator.AddressStreetPatternValidator()(control);
  }

}